import React from "react";
import NavbarWrapper from "../../../widgets/navbarWrapper";
import PatientTally from "./patientTally";

const Account = () => {
  return (
    <>
      <NavbarWrapper showNavbar={true} />
      <div className="flex flex-wrap items-center justify-between max-w-screen-xl px-4 py-5 mx-auto">
        <p className="text-2xl font-bold md:mt-20 mt-0 text-gray-900 montserrat">
          Welcome to Your Account
        </p>
        {/* Only View Stats – Subscription removed */}
        <div className="flex md:mt-20 mt-0">
          <button
            type="button"
            className="py-2.5 px-5 me-2 mb-2 text-sm font-medium text-white focus:outline-none bg-white rounded-lg border hover:bg-gray-100 focus:z-10 focus:ring-gray-200 dark:bg-gray-300 dark:text-white dark:hover:bg-gray-300"
            style={{ backgroundColor: "rgb(216,69,60)" }}
            onClick={() => {}} // no-op, since we only have one tab
          >
            View Stats
          </button>
          {/* Subscription button removed */}
        </div>
      </div>

      {/* Always show PatientTally */}
      <PatientTally />
    </>
  );
};

export default Account;